import { useOutletContext } from 'react-router-dom'

import { F0Box, F0Heading } from '@factorialco/f0-react'
import { type PlanningPeriodDetailQuery } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import DirectReporteesTable from 'modules/planning/components/DirectReporteesTable'
import OverviewSummaryCards from 'modules/planning/components/OverviewSummaryCards'

type PeriodDetailContext = {
  period: PlanningPeriodDetailQuery['planning']['period']
  periodId: string
}

const PeriodOverviewTab = () => {
  const { periodId } = useOutletContext<PeriodDetailContext>()
  const { company } = useCurrentSession()

  const currency =
    company.legalEntities?.find((entity) => entity.main)?.currency ?? company.currency ?? 'EUR'

  return (
    <F0Box display="flex" flexDirection="column" gap="3xl" paddingTop="md">
      <OverviewSummaryCards periodId={periodId} currency={currency} />
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Heading content={i18n.t('planning.overview.direct_reportees')} variant="heading" />
        <DirectReporteesTable periodId={periodId} currency={currency} />
      </F0Box>
    </F0Box>
  )
}

export default PeriodOverviewTab
